import Vue from 'vue';
import VeeValidate from 'vee-validate';

export default {
  install: (Vue, i18n) => {
    Vue.use(VeeValidate, { events: '', inject: false });

    const driver = VeeValidate.i18nDriver;

    const i18nDictionary = {
      get locale() {
        return i18n.locale();
      },
      set locale(val) {
        i18n.set(val);
      },
      getMessage(_, key, data) {
        const id = this.getPath(key);
        return i18n.translate(id, this.getData(data)) || driver.getMessage(_, key, data);
      },
      setMessage(locale, key, value) {
        driver.setMessage(locale, key, value);
        i18n.add(locale, { [this.getPath(key)]: value });
      },
      getAttribute(_, key) {
        const id = this.getPath(key);
        return i18n.translate(id);
      },
      setAttribute(locale, attr, value) {
        i18n.add(locale, { [this.getPath(attr)]: value });
      },
      getFieldMessage(_, field, rule, data) {
        const id = `${this.getPath(field)}.${rule}`;        
        return i18n.keyExists(id) ? i18n.translate(id, this.getData(data)) : this.getMessage(_, rule, data);
      },
      merge(dictionary) {
        // TODO
      },
      getDateFormat(locale) {
        // TODO
      },
      setDateFormat(locale, format) {
        // TODO
      },
      getPath(key){
        return key.includes('.') ? key.replace('.', '.validation.') : `validation.${key}`
      },
      getData(data){
        return data[1] ? Object.assign({}, ...data[1].map((value, index) => ({[index]: value}))) : {}
      }
    };

    VeeValidate.setI18nDriver('vuex-i18n', i18nDictionary);
  },
};



// WEBPACK FOOTER //
// ./_common/plugins/validation.plugin.js